<template>
  <div class="pay-phone-detail-div">
    <div class="pay-phone-cell-div">
      <van-field
        :readonly="true"
        
        :disabled="true"
        type="text"
        label="账户余额"
        input-align="right"
      >
        <template #label>
          <div class="pay-phone-div">
            <div>账户余额</div>
          </div>
        </template>
        <template #input>
          <span style="color:red;font-size: 16px;">{{ parseFloat(sUserInfo.amount).toFixed(2)+' 元' }}</span>
        </template>
      </van-field>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { Field } from "vant";
export default {
  name: "UserAmount",
  computed: mapGetters(["sUserInfo"]),
  components: {
    [Field.name]: Field,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.pay-code-div,
.pay-phone-cell-div,
.take-foot-div {
  border-radius: 5px;
}

.pay-phone-detail-div > div {
  background-color: #ffffff;
  margin-top: 10px;
  padding: 10px 0;
}

.pay-phone-div > div:first-child {
  color: #2d2d2d;
  font-size: 15px;
}
.pay-phone-div > div:last-child {
  color: #000000;
  font-size: 13px;
}

.pay-phone-cell-div .van-field__body {
  height: auto;
}

.pay-phone-cell-div .van-field__body input {
  font-size: 15px;
  font-weight: 500;
  height: 18px;
  margin-top: 10px;
}

.pay-phone-cell-div /deep/ .van-field__control:disabled {
  color: red;
  font-size: 15px;
  -webkit-text-fill-color: red;
}

.take-foot-div .van-cell__title {
  color: #2d2d2d;
  font-size: 15px;
}

.pay-phone-cell-div /deep/ .van-field__label {
  width: auto;
}
</style>